/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Mobile_Percent_CompleteInputs */

const en_mobile_percent_complete = /** @type {(inputs: Mobile_Percent_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.percent}% COMPLETE`)
};

const es_mobile_percent_complete = /** @type {(inputs: Mobile_Percent_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.percent}% COMPLETADO`)
};

/**
* | output |
* | --- |
* | "{percent}% COMPLETE" |
*
* @param {Mobile_Percent_CompleteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_percent_complete = /** @type {((inputs: Mobile_Percent_CompleteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Percent_CompleteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_percent_complete(inputs)
	return en_mobile_percent_complete(inputs)
});